// src/services/redeemOtpService.js
import ApiService from './api'

class RedeemOtpService {
  /**
   * Request OTP for points redemption
   * @param {string} orderId - Order ID
   * @param {number} pointsToRedeem - Points to redeem
   * @returns {Promise} - API response
   */
  async requestRedeemOtp(orderId, pointsToRedeem) {
    try {
      console.log('📱 Requesting redeem OTP:', { orderId, pointsToRedeem })
      
      const response = await ApiService.post('/redeem-otps', {
        order: orderId,
        pointsToRedeem: pointsToRedeem
      })
      
      console.log('✅ Redeem OTP request response:', response)
      return response
    } catch (error) {
      console.error('❌ Error requesting redeem OTP:', error)
      throw error
    }
  }

  /**
   * Verify OTP for points redemption
   * @param {string} redeemOtpId - Redeem OTP ID
   * @param {string} otp - OTP code
   * @returns {Promise} - API response
   */
  async verifyRedeemOtp(redeemOtpId, otp) {
    try {
      console.log('✅ Verifying redeem OTP:', { redeemOtpId, otp })
      
      const response = await ApiService.post(`/redeem-otps/${redeemOtpId}/verify`, {
        otp: otp
      })
      
      console.log('✅ Redeem OTP verification response:', response)
      return response
    } catch (error) {
      console.error('❌ Error verifying redeem OTP:', error)
      throw error
    }
  }
}

export default new RedeemOtpService()
